import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/storage';
import './index.scss';
import {addProtectedLinksToPage, registerServiceWorker} from './utils';
import {startMatrix, stopMatrix} from './matrix';
import {createStockPlaceholders, displayStockPrices} from './stocks';

firebase.initializeApp({
  apiKey: 'AIzaSyA5NiEUjgKpDf0F_2KWEnDJQkxIUAyvYqY',
  authDomain: 'matmo.app',
  databaseURL: 'https://matmo-app-123.firebaseio.com',
  projectId: 'matmo-app-123',
  storageBucket: 'matmo-app-123.appspot.com',
  messagingSenderId: '1035218496780',
});

firebase.auth().onAuthStateChanged((user: firebase.User | null) => {
  const isUserLoggedIn = !!user;

  if (isUserLoggedIn) {
    onceUserLoggedIn();
  } else {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).catch(console.error);
  }
});

function onceUserLoggedIn() {
  firebase
    .storage()
    .ref('protected-links.json')
    .getDownloadURL()
    .then((url: string) => fetch(url))
    .then((res) => res.json())
    .then(addProtectedLinksToPage);

  displayStockPrices();
}

window.addEventListener('load', () => {
  if ('serviceWorker' in navigator) registerServiceWorker();

  createStockPlaceholders();

  const searchInput = document.getElementById('search');
  searchInput.focus();
  searchInput.onkeyup = (ev: KeyboardEvent) => {
    if (ev.keyCode === 13) {
      const searchValue: string = (ev.target as HTMLInputElement).value;
      window.location.href = `https://claude.ai/new?q=${encodeURIComponent(searchValue)}`;
    }
  };

  const today = new Date();
  const dayOfYear = Math.floor((today.getTime() - new Date(today.getFullYear(), 0, 0).getTime()) / 1000 / 60 / 60 / 24);
  const progressInCurrentYear = Math.floor((dayOfYear / 365) * 100);
  const progressPct = `${progressInCurrentYear}%`;
  document.getElementById('progress').style.width = progressPct;
  document.getElementById('day-percent').innerText = progressPct;
  document.getElementById('day-number').innerText = `Day ${dayOfYear}`;

  const matrixToggle = document.getElementById('matrix-toggle') as HTMLInputElement;
  let matrixIntervalId: number | null = null;

  const setMatrixState = (isMatrixOn: boolean) => {
    if (isMatrixOn) {
      document.body.classList.remove('gradient-background');
      if (matrixIntervalId === null) {
        matrixIntervalId = startMatrix();
      }
    } else {
      document.body.classList.add('gradient-background');
      if (matrixIntervalId !== null) {
        stopMatrix(matrixIntervalId);
        matrixIntervalId = null;
      }
    }
    localStorage.setItem('matrix-enabled', String(isMatrixOn));
  };

  matrixToggle.addEventListener('change', (ev: Event) => {
    const isChecked = (ev.target as HTMLInputElement).checked;
    setMatrixState(isChecked);
  });

  const isMatrixEnabledFromStorage = localStorage.getItem('matrix-enabled');
  if (isMatrixEnabledFromStorage === null) {
    // Default to on if no preference is stored
    matrixToggle.checked = true;
    setMatrixState(true);
  } else {
    const isMatrixOn = isMatrixEnabledFromStorage === 'true';
    matrixToggle.checked = isMatrixOn;
    setMatrixState(isMatrixOn);
  }
});

fetch(
  'https://api.openweathermap.org/data/2.5/weather?lat=38.829848&lon=-121.2513619&appid=e26de5bfac584a4e709390e69550db46&units=imperial',
)
  .then((res) => res.json())
  .then((weatherData) => {
    const imgIcons = (weatherData.weather || [])
      .map(
        (w: any) => `
      <a class="weather-icon" href="https://www.google.com/search?q=weather" target="_blank">
        <img src="https://openweathermap.org/img/w/${w.icon}.png" alt="${w.description}">
      </a>
    `,
      )
      .join('');

    document.getElementById('weatherData').innerHTML = `
      <a class="weather-data-link" href="https://www.google.com/search?q=weather" target="_blank">
        <div class="flex">
          <div class="min-temp">${Math.round(weatherData.main.temp_min)}</div>
          <div>----</div>
        </div>
        <div class="current-temp"><div>${Math.round(weatherData.main.temp)}</div></div>
        <div class="flex">
          <div>----</div>
          <div class="max-temp">${Math.round(weatherData.main.temp_max)} </div>
        </div>
      </a>
    `;
    document.getElementById('weather-icons').innerHTML = `<div>${imgIcons}</div>`;
  });
